import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class StorageService {

    public saveToStorage<T>(key: string, data: T) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    public getFromStorage<T>(key: string) {
        const data = localStorage.getItem(key);
        if (data) {
            try {
                return JSON.parse(data) as T;
            } catch {
                localStorage.removeItem(key);
                return null;
            }
        }
        return null;
    }

    public removeFromStorage(key: string) {
        localStorage.removeItem(key);
    }
}
